/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsChevronsDoubleMiniLeft: {
  name: 'chevrons-double-mini-left';
  data: string;
} = {
  name: 'chevrons-double-mini-left',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.707 9.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L8.414 12l2.293-2.293Zm6 0a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L14.414 12l2.293-2.293Z" fill="currentColor"/></svg>`,
};
